import { createFileRoute } from "@tanstack/react-router";
import { SourceTemplatesPage } from "./-source-templates/source-templates.page";

export const Route = createFileRoute("/source-templates/")({
  component: SourceTemplatesPage,
});
